import { defineComponent, Teleport, Transition } from 'vue'
import './index.scss'
export default defineComponent({
  name: 'GfrToast',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: String,
    duration: {
      type: Number,
      default: 3000
    },
    closeOnClick: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:show'],
  setup(props, { emit }) {
    let timer: any = null
    const hideToast = () => {
      if (!props.closeOnClick) return false
      emit('update:show', false)
      clearTimeout(timer)
    }
    watch(
      () => props.show,
      (show) => {
        if (show) {
          timer = setTimeout(() => {
            emit('update:show', false)
            clearTimeout(timer)
          }, props.duration)
        } else {
          clearTimeout(timer)
        }
      }
    )
    return () => (
      <Teleport to={'body'}>
        <Transition name={'tran-fadeIn'}>
          <div v-show={props.show} class={'gfr-toast'} onClick={hideToast}>
            <div class={'gfr-toast-inner'}>{props.message}</div>
          </div>
        </Transition>
      </Teleport>
    )
  }
})
